import { render, staticRenderFns } from "./ProductDetailOrderBtn.vue?vue&type=template&id=1c8bd7ea&"
import script from "./ProductDetailOrderBtn.vue?vue&type=script&lang=js&"
export * from "./ProductDetailOrderBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports